import { SkeletonText } from "@zapier/design-system";
import styles from "./ListItems.module.css";

export type ListItemType = {
  icon?: React.ReactNode;
  text?: string;
  rightIcon?: React.ReactNode;
  link?: string;
};

interface ListItemProps {
  item?: ListItemType;
}

const ListItem = ({ item }: ListItemProps) => {
  if (!item) {
    return (
      <div className={styles.item}>
        <SkeletonText lines={1} width="20px" />
        <SkeletonText lines={1} width="80px" />
        <SkeletonText lines={1} width="20px" />
      </div>
    );
  }

  return (
    <div className={styles.item}>
      {item.icon ? <div className={styles.icon}>{item.icon}</div> : <div />}
      {item.link ? (
        <a
          className={styles.link}
          href={item.link}
          target="_blank"
          rel="noreferrer"
        >
          {item.text}
        </a>
      ) : (
        <div>{item.text}</div>
      )}
      {item.rightIcon || <div />}
    </div>
  );
};

export default ListItem;
